import React, { useState, useEffect } from "react";
import Navbar2 from "../Components/Navbar2";
import Footer2 from "../Components/Footer2";
import { getOurServices } from "../Common/apis"
import { useNavigate } from 'react-router-dom'
import Aos from "aos";

function GisulServices() {
  useEffect(() => {
    Aos.init({
      duration: 1000, // animation duration in ms
      once: true,     // animate only once
    });
  }, []);
  // const [services, setServices] = useState([]);
  // const [loading, setLoading] = useState(true);
  const navigate = useNavigate()

  useEffect(() => {
    // const fetchServices = async () => {
    //   try {
    //     const res = await getOurServices();
    //     setServices(res.data); // assuming API returns `data: []`
    //   } catch (err) {
    //     console.error("Error fetching services:", err);
    //   } finally {
    //     setLoading(false);
    //   }
    // };

    // fetchServices();
  }, []);

  return (
    <>
      <div className="new-home">
        <Navbar2 />
        <div className="md:hidden flex justify-center items-center">
        <img data-aos="fade-right" alt="" className="px-[26px]" src="/assets/services/logo.svg" />
        </div>
        <div className="grid xl:grid-cols-2 grid-cols-1 xl:gap-[100px] items-start md:gap-[68px] gap-[34px] md:pt-[50px] pt-[30px] xl:px-[100px] lg:px-[100px] px-[20px] md:pb-[60px] pb-[0px]">
          {/* {loading ? (
            <p>Loading services...</p>
          ) : ( */}
            <div className="grid grid-cols-2 items-center justify-center gap-[16px] gap-y-[26px]">
                <div data-aos="flip-up" className='relative max-w-[280px] w-full pb-[11px]'>
                  <img src="/assets/services/item4.svg" alt="" />
                  <button onClick={() => navigate("/corporate-hiring")} className='bg-[#6953A3] rounded-[120px] py-[2px] font-sans font-[500] md:text-[24px] text-[14px] leading-[22px] text-[#FFFFFF] md:h-[50px] h-[31px] absolute bottom-[0px] left-[50%] translate-x-[-50%] w-full md:max-w-[198px] max-w-[130px]'>Lateral Hiring</button>
                </div>
                <div data-aos="flip-up" className='relative max-w-[280px] w-full pb-[11px]'>
                  <img src="/assets/services/item3.svg" alt="" />
                  <button onClick={() => navigate("/train")} className='bg-[#6953A3] rounded-[120px] py-[2px] font-sans font-[500] md:text-[24px] text-[14px]  leading-[22px] text-[#FFFFFF] md:h-[50px] h-[31px] absolute bottom-[0px] left-[50%] translate-x-[-50%] w-full md:max-w-[198px] max-w-[130px]'>Hire Train Depoy</button>
                </div>
              <div data-aos="flip-up" className='relative max-w-[280px] w-full pb-[11px]'>
                <img src="/assets/services/item5.svg" alt="" />
                <button onClick={() => navigate("/cloudlab")} className='bg-[#6953A3] rounded-[120px] py-[2px] font-sans font-[500] md:text-[24px] text-[14px]  leading-[22px] text-[#FFFFFF] md:h-[50px] h-[31px] absolute bottom-[0px] left-[50%] translate-x-[-50%] w-full md:max-w-[198px] max-w-[130px]'>Cloud Labs</button>
              </div>
              <div data-aos="flip-up" className='relative max-w-[280px] w-full pb-[11px]'>
                <img src="/assets/services/item6.svg" alt="" />
                <button onClick={() => navigate("/assessment")} className='bg-[#6953A3] rounded-[120px] py-[2px] font-sans font-[500] md:text-[24px] text-[14px]  leading-[22px] text-[#FFFFFF] md:h-[50px] h-[31px] absolute bottom-[0px] left-[50%] translate-x-[-50%] w-full md:max-w-[198px] max-w-[130px]'>Assessment</button>
              </div>
              <div data-aos="flip-up" className='relative max-w-[280px] w-full pb-[11px]'>
                <img src="/assets/services/item7.svg" alt="" />
                <button onClick={() => navigate("/lms2")} className='bg-[#6953A3] rounded-[120px] py-[2px] font-sans font-[500] md:text-[24px] text-[14px]  leading-[22px] text-[#FFFFFF] md:h-[50px] h-[31px] absolute bottom-[0px] left-[50%] translate-x-[-50%] w-full md:max-w-[198px] max-w-[130px]'>LMS</button>
              </div>
            </div>
          {/* )} */}
          <div className="flex flex-col justify-end gap-[54px] items-end">
            {/* services.map((service) => (
                <div data-aos="fade-right" key={service._id} className="new-services-card" onClick={() => navigate(`/service/${service._id}`)}>
                  <img src={service.image} alt={service.title} />
                  <div className="ser-title">
                    <p>{service.title}</p>
                  </div>
                </div>
              )) */}
            <img data-aos="fade-right" alt="" className="md:block hidden" src="/assets/services/logo.svg" />
            <img data-aos="fade-left" alt="" className="ser-2-img md:p-0 p-[34px]" src="/assets/services/vector.svg" />
          </div>
        </div>
        {/* <div className="so-3-img">
          <img className="" src={img2} />
        </div> */}
        <Footer2 />
      </div>
    </>
  );
}

export default GisulServices;
